<template>
  <div>
    <table class="table table-hover table-responsive-md">
      <thead>
        <tr style="background-color:#eee;">
          <th style="width:40px;"></th>
          <th>Task</th>
          <th class="d-sm-down-none">Submitted</th>
          <th>Status</th>
        </tr>
      </thead>
      <tbody v-if="loaded">
        <tr v-for="submission in submissions.data" :key="submission.id">
          <td>
            <font-awesome-icon icon="thumbs-down" class="text-red" v-if="submission.grade_status === 0"></font-awesome-icon>
            <font-awesome-icon icon="thumbs-up" class="text-lime" v-else-if="submission.grade_status === 1"></font-awesome-icon>
            <font-awesome-icon icon="clock" v-else-if="submission.grade_status === 2"></font-awesome-icon>
          </td>
          <td>
            <router-link :to="'/submissions/' + submission.id">{{ submission.form_name }}</router-link>
          </td>
          <td class="d-sm-down-none">{{ submission.created_at | moment('calendar') }}</td>
          <td>{{ submission.grade_status_text }}</td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr>
          <td colspan="4">
            <loading-spinner :loading="true"></loading-spinner>
          </td>
        </tr>
      </tbody>
    </table>
    <b-btn-group block class="w-100">
      <b-button flat squared variant="primary" :to="'/submissions?page=1&limit=10&sortBy=updated_at&sort=desc&filter[grade_status]=2&filter[user.name_full]=' + user.name_full">View Ungraded</b-button>
      <b-button flat squared  :to="'/submissions?page=1&limit=10&sortBy=updated_at&sort=desc&filter[user.name_full]=' + user.name_full">View All</b-button>
      <b-button flat squared variant="success" :to="'/submissions?page=1&limit=10&sortBy=updated_at&sort=desc&filter[grade_status]=1&filter[user.name_full]=' + user.name_full">View Satisfactory</b-button>
      <b-button flat squared variant="danger" :to="'/submissions?page=1&limit=10&sortBy=updated_at&sort=desc&filter[grade_status]=0&filter[user.name_full]=' + user.name_full">View Unsatisfactory</b-button>
    </b-btn-group>
  </div>
</template>

<script>
export default {
  name: 'StudentSubmissions',
  data () {
    return {
      submissions: {
        data: [],
        limit: 10,
        unlimited: false
      },
      loaded: false
    };
  },
  methods: {
    loadSubmissions () {
      const subQuery = {
        'grade_status': 2,
        'includes': 'user',
        limit: 10
      };

      if (this.user_id) {
        subQuery.user_id = this.user_id;
      }

      this.loaded = false;
      this.axios.get('submissions', {params: subQuery}).then(rsp => {
        this.submissions.data = rsp.data.data.map(sub => {
          switch (sub.grade_status) {
            case 0:
              sub.grade_status_text = 'Not Satisfactory';
              break;
            case 1:
              sub.grade_status_text = 'Satisfactory';
              break;
            case 2:
              sub.grade_status_text = 'Pending..';
              break;
            default:
              sub.grade_status_text = '';
              break;
          }

          return sub;
        });

        this.loaded = true;
      }).catch(err => this.$errorOut(err));
    }
  },
  mounted () {
    this.loadSubmissions();
  },
  props: ['user_id', 'user']
};
</script>

<style scoped>

</style>
